module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (51).b117c439.jpg";